import {useEffect} from "react";
import {useStatePair} from "../../../../../../type/States";
import { Image, mergeClasses} from "@fluentui/react-components";
import {Column, Row} from "../../../../common/Layout";
import {useStyles} from "../../../../../../styles/mission/ver1";
import {
    useCurrentPageUpdate, useGuideExpirationDateUpdate, useHiddenGuideList, useHiddenGuideListUpdate, useNextPageUpdate
} from "../../../../../../stores/useStore";
import {
    ShoppingPresentationValueObject
} from "../../../../../../model/vo/content/ShoppingPresentationValueObject";
import {ShoppingPathJointEventIO} from "../../../../../../io/content/shoppingPathJointEventIO";
import {EventType} from "../../../../../../constant/EventType";
import {useUserStore} from "../../../../../../stores/useUserStore";

export default function GuideLine({data,primaryColor}: {data:ShoppingPresentationValueObject | null,primaryColor:string}) {
    const images = useStatePair<string[]>([])
    const currentImage = useStatePair<number>(0)

    const basicStyle = useStyles()

    const updateCurrentPage = useCurrentPageUpdate()
    const updateNextPage = useNextPageUpdate()
    const updateDueDate = useGuideExpirationDateUpdate()
    const updateHiddenList = useHiddenGuideListUpdate()
    const hiddenList = useHiddenGuideList()

    const userInfo = useUserStore();

    const onClickGuideLineInvisibleBtn = () => {
        updateDueDate(new Date())
        updateCurrentPage("Mission")

        if (data?.mappedImageUrls["0"]?.fileUrl) {
            updateHiddenList([...hiddenList, data.mappedImageUrls["0"].fileUrl]);
        }
    }

    const onClickMissionBtn = () => {
        updateCurrentPage("Mission");
        updateNextPage("Mission");
    }

    useEffect(() => {
        const getGuideLineImages = async () => {
            if (!data?.mappedImageUrls) return;

            const sortedImages = Object.entries(data.mappedImageUrls)
                .sort(([keyA], [keyB]) => Number(keyA) - Number(keyB))  // 키 값으로 정렬
                .map(([_, value]) => value?.fileUrl)  // null이 아닌 경우만 fileUrl 추출
                .filter((url): url is string => url != null);  // null 제거

            images.setValue(sortedImages);
        };

         getGuideLineImages();
    }, [data]);

    return (
            <div style={{width:'100vw',height:'100vh',backgroundColor:primaryColor}}>
                <Image
                alt="가이드라인이미지"
                src={images.value[currentImage.value]}
                style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                }}
                />

            <div className={basicStyle.fixedBottom}>
                <Column>
                    <Row gap={'8px'}>
                        {/*{*/}
                        {/*    currentImage.value == 0 ?*/}
                        {/*        (*/}
                        {/*            <div onClick={onClickGuideLineInvisibleBtn}*/}
                        {/*                    className={mergeClasses(basicStyle.roundedBtn, basicStyle.outlinedBtn)}*/}
                        {/*                    style={{flex:1}}*/}
                        {/*            >*/}
                        {/*                오늘 하루 보지 않기*/}
                        {/*            </div>*/}
                        {/*        )*/}
                        {/*        :*/}
                        {/*    (*/}
                        {/*        <div*/}
                        {/*            onClick={()=>{if(currentImage.value != 0){currentImage.setValue(currentImage.value - 1)}}}*/}
                        {/*            className={mergeClasses(basicStyle.roundedBtn, basicStyle.outlinedBtn)}*/}
                        {/*            style={{flex:1}}*/}
                        {/*        >이전</div>*/}
                        {/*    )*/}
                        {/*}*/}
                        {
                            currentImage.value != 0 &&
                                (
                                    <div
                                        onClick={()=>{if(currentImage.value != 0){currentImage.setValue(currentImage.value - 1)}}}
                                        className={mergeClasses(basicStyle.roundedBtn, basicStyle.outlinedBtn)}
                                        style={{flex:1}}
                                    >이전</div>
                                )
                        }
                        {/*{*/}
                        {/*    currentImage.value == 0 ?*/}
                        {/*        (*/}
                        {/*            <div onClick={()=>{*/}
                        {/*                currentImage.setValue(images.value.length - 1)*/}
                        {/*            }}*/}
                        {/*                    className={mergeClasses(basicStyle.roundedBtn, basicStyle.outlinedBtn)}*/}
                        {/*                    style={{flex:1}}*/}
                        {/*            >*/}
                        {/*                바로 미션하기*/}
                        {/*            </div>*/}
                        {/*        )*/}
                        {/*        :*/}
                        {/*    (*/}
                        {/*        <div*/}
                        {/*            onClick={()=>{if(currentImage.value != 0){currentImage.setValue(currentImage.value - 1)}}}*/}
                        {/*            className={mergeClasses(basicStyle.roundedBtn, basicStyle.outlinedBtn)}*/}
                        {/*            style={{flex:1}}*/}
                        {/*        >이전</div>*/}
                        {/*    )*/}
                        {/*}*/}
                        {
                            currentImage.value == images.value.length - 1 ?
                                <div className={mergeClasses(basicStyle.roundedBtn, basicStyle.primaryBtn)}
                                     onClick={onClickMissionBtn}
                                     style={{flex: 1, backgroundColor: primaryColor,border: `1.5px solid ${primaryColor}`,}}
                                >미션하러가기</div>
                                :
                                <div className={mergeClasses(basicStyle.roundedBtn, basicStyle.primaryBtn)}
                                     onClick={() => {
                                         if(currentImage.value == 0){
                                             if (data && data.shoppingPathJointId && data.userId && userInfo.misc) {
                                                 ShoppingPathJointEventIO.post({
                                                     shoppingPathJointId: data.shoppingPathJointId,
                                                     userId: data.userId,
                                                     misc: userInfo.misc,
                                                     eventType: EventType.ShoppingParticipationMethodClick
                                                 }).then(
                                                     v => console.log(v)
                                                 ).catch(e => console.error(e))
                                             }
                                         }
                                         currentImage.setValue(currentImage.value + 1)
                                     }}
                                     style={{flex: 1, backgroundColor: primaryColor,border: `1.5px solid ${primaryColor}`,}}
                                >{currentImage.value == 0 ? '참여방법 보기' : '다음으로'}</div>
                        }
                    </Row>
                </Column>
            </div>
        </div>
    )
}